export default {
    JSError: 'JSError',
    JWTAuthError: 'JWTAuthError',
    StudentsAPIError: 'StudentsAPIError',
    SLError: 'SLError'
};